import { Inject, Injectable, InjectionToken } from '@angular/core';

// Klucz Google Maps JS API. Kazda aplikacja dostarcza wlasna wartosc w swoim
// module - dokladnie tak, jak wczesniej przekazywala ja do AgmCoreModule.forRoot().
export const GOOGLE_MAPS_API_KEY = new InjectionToken<string>('GOOGLE_MAPS_API_KEY');

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {

  private loadPromise: Promise<void>;

  constructor(@Inject(GOOGLE_MAPS_API_KEY) private apiKey: string) { }

  // @agm/core doladowywal skrypt Google Maps samodzielnie. @angular/google-maps
  // tego nie robi i wymaga, zeby obiekt google.maps istnial juz w chwili
  // tworzenia komponentu <google-map>. Dlatego kazdy ekran z mapa musi
  // poczekac na to Promise, zanim wyrenderuje mape.
  load(): Promise<void> {
    if (!this.loadPromise) {
      this.loadPromise = new Promise<void>((resolve, reject) => {

        if ((window as any).google && (window as any).google.maps) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.apiKey;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Nie udało się załadować map Google.'));
        document.head.appendChild(script);
      });
    }

    return this.loadPromise;
  }
}
